import React from 'react';
import { Chip as RNPChip } from 'react-native-paper';

export type ChipProps = React.ComponentProps<typeof RNPChip>;

export default function Chip(props: ChipProps) {
  return <RNPChip {...props} />;
}
